import makeStyles from '@material-ui/core/styles/makeStyles';
import { ISpcTheme } from '../../../../../../../common/theme/ISpcTheme';

export type ValueWithLabelClasses = 'container' | 'label' | 'value';

const valueWithLabelStyles = makeStyles<ISpcTheme, ValueWithLabelClasses>(
  ({ palette, typography, breakpoints }) => ({
    container: {
      minWidth: 'max-content',
    },
    value: {
      color: palette.text.secondary,
      fontFamily: typography.fontFamily2,
      fontSize: typography.fontLG,
      lineHeight: '24px',
      margin: 0,

      [breakpoints.down('xs')]: {
        fontSize: typography.fontMD,
      },
    },
    label: {
      color: palette.text.secondary,
      fontSize: typography.fontXS,
      lineHeight: '14px',

      [breakpoints.down('sm')]: {
        fontSize: typography.fontXXS,
        lineHeight: '12px',
      },
    },
    percentageSimple: {
      borderLeft: `1px solid ${palette.text.disabled}`,
      paddingLeft: 15,
    },
  }),
  { name: 'Calculator_PercentageWithLabel' },
);

export default valueWithLabelStyles;
